<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="downloadExcelDeposit"
          >下载Excel</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-check"
            plain
            @click.stop="passToWxs()"
          >同意提现到微信零钱</el-button>
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="depositSign('','NORMAL')"
          >提现正常</el-button>
          <el-button
            type="danger"
            icon="el-icon-close"
            size="small"
            plain
            @click.stop="depositSign('','ABNORMAL')"
          >提现异常</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            v-if="scope.row.status=='SUBMIT_APPLICATION'"
            @click.stop="passToBank(scope.row.id)"
          >提交银行处理</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-check"
            plain
            v-if="scope.row.status=='WAIT_AUDIT'"
            @click.stop="passToWx(scope.row.id)"
          >同意提现到微信零钱</el-button>
          <el-button
            type="warning"
            icon="el-icon-close"
            size="small"
            plain
            v-if="scope.row.status=='WAIT_AUDIT'"
            @click.stop="refuseToWx(scope.row.id)"
          >拒绝</el-button>

          <el-button
            type="warning"
            icon="el-icon-close"
            size="small"
            plain
            v-if="scope.row.status=='SUBMIT_APPLICATION'"
            @click.stop="reject(scope.row.id)"
          >拒绝</el-button>

          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            v-if="scope.row.status=='SUBMISSION_OF_BANKING'"
            @click.stop="pass(scope.row.id)"
          >已提现</el-button>
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            v-if="scope.row.depositStatus=='WAIT_SIGN'"
            @click.stop="depositSign(scope.row.id,'NORMAL')"
          >提现正常</el-button>
          <el-button
            type="danger"
            icon="el-icon-close"
            size="small"
            plain
            v-if="scope.row.depositStatus=='WAIT_SIGN'"
            @click.stop="depositSign(scope.row.id,'ABNORMAL')"
          >提现异常</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="status"
        >
          <el-tag
            v-for="obj of CashWithdrawalStatus"
            :key="obj.value"
            v-if="obj.value == scope.row.status"
          >{{obj.label}}</el-tag>
        </template>
        <template
          slot-scope="scope"
          slot="depositStatus"
        >
          <el-tag
            v-for="obj of WalletDepositStatus"
            :key="obj.value"
            v-if="obj.value == scope.row.depositStatus"
          >{{obj.label}}</el-tag>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { walletDepositOption } from "@/const/salesCloud/walletDepositOption";
import {
  findWalletDeposit,
  reject,
  passToBank,
  pass,
  WxPass,
  WxRefuse,
  findWalletDepositDownloadExcel,
  depositSign, //提现状态改变
} from "@/api/salesCloud/walletDeposit";
import { findByLabel, formatterTime } from "@/util/util";
import { excelaxios } from "@/util/excelaxios";
import { DIC } from "@/const/dic";

export default {
  name: "walletDeposit",
  data() {
    return {
      tableOption: walletDepositOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      ids: [],
      CashWithdrawalStatus: DIC.WALLET_DEPOSIT_AUDIT,
      WalletDepositStatus: DIC.WALLET_DEPOSIT_STATUS,
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    depositSign(id, val) {
      let params = {};
      if (id) {
        console.log("单点");
        let ids = id;
        params.ids = ids;
      } else {
        console.log("批量");
        let ids = this.ids;
        params.ids = ids;
        console.log(ids.length);
        if (ids.length == 0) {
          this.$message({
            showClose: true,
            message: "请选择操作数据",
            type: "error",
          });
          return;
        }
      }
      params.depositStatus = val;
      this.$confirm(`是否确认更改提现状态?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          depositSign(params).then((response) => {
            if (response.code == "200") {
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });
              this.refreshChange(this.page);
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch((error) => {});
    },
    passToWxs() {
      let ids = this.ids;
      let params = new Object();
      params.ids = ids;
      WxPass(params).then((response) => {
        if (response.code == "200") {
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success",
          });
          this.refreshChange(this.page);
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
      console.log(ids);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findWalletDeposit(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findWalletDeposit(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
       if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      }
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findWalletDeposit(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(params);
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      findWalletDeposit(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      this.downloadData = params;
      findWalletDeposit(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {},
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      console.log(val);
      let ids = [];
      for (let i of val) {
        console.log(i);
        ids.push(i.id);
      }
      this.ids = ids;
      console.log(ids);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {},
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {},
    reject(id) {
      this.$prompt("请输入拒绝原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: "请输入正确长度的备注信息1-255",
      })
        .then(({ value }) => {
          let obj = {};
          obj.id = id;
          obj.refusedReason = value;
          reject(obj).then((response) => {
            if (response.code == "200") {
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });
              this.refreshChange(this.page);
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: "提交出错",
            type: "error",
          });
        });
    },
    downloadExcelDeposit() {
      let params = this.downloadData;
      findWalletDepositDownloadExcel(params).then((res) => {
       window.location.href=res;
      });
    },
    refuseToWx(id) {
      this.$prompt("请输入拒绝原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: "请输入正确长度的备注信息1-255",
      })
        .then(({ value }) => {
          let obj = {};
          obj.id = id;
          obj.refusedReason = value;
          WxRefuse(obj).then((response) => {
            if (response.code == "200") {
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });
              this.refreshChange(this.page);
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: "提交出错",
            type: "error",
          });
        });
    },
    passToWx(id) {
      let params = new Object();
      params.ids = id;
      WxPass(params).then((response) => {
        if (response.code == "200") {
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success",
          });
          this.refreshChange(this.page);
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },
    passToBank(id) {
      this.$prompt("请输入凭证", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: "请输入正确长度的备注信息1-255",
      })
        .then(({ value }) => {
          let obj = {};
          obj.id = id;
          obj.tradeNumber = value;
          passToBank(obj).then((response) => {
            if (response.code == "200") {
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });
              this.refreshChange(this.page);
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: "提交出错",
            type: "error",
          });
        });
    },
    pass(id) {
      this.$confirm(`是否确认已提现?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let obj = {};
          obj.id = id;
          pass(obj)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "操作成功",
                  type: "success",
                });
                this.refreshChange(this.page);
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
